import { useState } from "react";
import { Footer } from "../components/Footer";
import { FiArrowUpRight, FiFileText } from "react-icons/fi";
import hiringPackagePdf from "../files/SFURS_Hiring_Package.pdf";

export const Join = () => {
  const [techRoles, setTechRoles] = useState(true);

  const ENGINEER_APPLICATION_FORM = "https://forms.gle/Husak3ciXQfNdNzn7";
  const BUSINESS_TEAM_APPLICATION_FORM = "https://forms.gle/zUAeEEWMYD1hdrZX6";
  const APPLICATIONS_OPEN = true;

  // Business team — aligned with OpenRoles / SFURS_Hiring_Package.pdf (2026)
  const openRoles = [
    {
      name: "VP Operations",
      description:
        "Manage the club’s day to day operations, including project timelines, event planning, bookings, logistics, and internal coordination. Ensure teams stay organized, meet deadlines, and have the resources needed to execute their work. Strong organization, communication, problem solving, and project management skills are essential; experience with logistics, events, scheduling, or operations is preferred.",
      linkApply: BUSINESS_TEAM_APPLICATION_FORM,
      descriptionLink: null,
      goTo: "/join",
    },
    {
      name: "VP Marketing",
      description:
        "Maintain and strengthen the club’s brand across platforms and materials. Lead promotion for major initiatives and keep messaging consistent and engaging. Document club activities through photography and media for promotion and archives. Ideal for someone with strong social and content skills, clear visual communication, and reliable execution on deadlines.",
      linkApply: BUSINESS_TEAM_APPLICATION_FORM,
      descriptionLink: null,
      goTo: "/join",
    },
  ];

  const openRolesTech = [
    {
      name: "Mechanics Co-Lead",
      description:
        "Lead the mechanics team in designing the physical components that bring our robots to life. You’ll guide system-level planning, delegate work, and keep the team on track through bi-weekly meetings and lead syncs. Research materials and drive mechanical quality while collaborating with other leads. SolidWorks experience and proven leadership are key.",
      linkApply: ENGINEER_APPLICATION_FORM,
      descriptionLink: null,
      goTo: "/teams/mechanics",
    },
    {
      name: "Mechanics Engineer",
      description:
        "Design and prototype mechanical and electromechanical systems for our robots using CAD and fabrication (including 3D printing where useful). Research materials, improve designs over time, and meet regularly with the mechanics team. Hands-on work that turns concepts into parts that perform in competition.",
      linkApply: ENGINEER_APPLICATION_FORM,
      descriptionLink: null,
      goTo: "/teams/mechanics",
    },
    {
      name: "Electronics Engineer",
      description:
        "Design and modify custom PCBs in Altium, bring up and troubleshoot boards, and integrate new components with the rest of the robot. Assembly, rework, and strong electronics fundamentals required; firmware exposure is a plus. You’ll help ensure reliable, high-performance electronics on the platform.",
      linkApply: ENGINEER_APPLICATION_FORM,
      descriptionLink: null,
      goTo: "/teams/electronics",
    },
    {
      name: "Firmware Developer",
      description:
        "Develop real-time firmware in embedded C for our robots: protocols, scheduling, and integration across subsystems. Participate in reviews, debugging, and optimization; partnership with electronics and software is ongoing. Familiarity with microcontrollers (e.g. STM32, Microchip), buses like I2C/SPI/UART/CAN, and embedded best practices is important.",
      linkApply: ENGINEER_APPLICATION_FORM,
      descriptionLink: null,
      goTo: "/teams/firmware",
    },
    {
      name: "Software Developer",
      description:
        "Implement features in C++ in a collaborative, Linux-friendly workflow across Agent, path planning, integration, and related areas. Own tickets and merge requests, document your work, and adapt in a fast-moving robotics codebase. Motivation, teamwork, and solid C++ fundamentals matter; Qt or open-source contributions are a plus.",
      linkApply: ENGINEER_APPLICATION_FORM,
      descriptionLink: null,
      goTo: "/teams/software",
    },
  ];

  const visibleBusinessRoles = APPLICATIONS_OPEN ? openRoles : [];
  const visibleTechRoles = APPLICATIONS_OPEN ? openRolesTech : [];

  const closedMessage =
    "Applications are currently closed. Check back later or follow us @sfurobotsoccer on Instagram for updates.";
  const noRolesMessage = (
    <>
      There are currently no positions available at the moment. Follow us
      @sfurobotsoccer on Instagram and join our{" "}
      <a
        className="text-red-700"
        href="https://discord.com/invite/CK3nws9YPY"
        target="_blank"
        rel="noopener noreferrer"
      >
        discord
      </a>{" "}
      to find out when the next openings get released!
    </>
  );

  return (
    <>
      <div className="pt-24 lg:pt-28 overflow-hidden flex flex-col items-center lg:items-start lg:items-col px-6 lg:px-20">
        <h2 className="text-3xl plus-jakarta-sans-heading text-left w-full mb-3">
          Join The Team
        </h2>

        <h3 className="plus-jakarta-sans-heading text-2xl mb-0">Open Roles</h3>

        <a
          href={hiringPackagePdf}
          target="_blank"
          rel="noopener noreferrer"
          className="plus-jakarta-sans-body text-sm font-semibold text-red-700 underline underline-offset-2 mt-2 mb-0 w-11/12"
        >
          View full hiring package (PDF)
        </a>

        <p className="plus-jakarta-sans-body text-black w-11/12 text-sm lg:mb-5 text-opacity-60 leading-6 mt-2">
          {APPLICATIONS_OPEN ? (
            <>
              Interested in robotics and soccer? We’re hiring for business and
              technical roles for our 2026 team—switch below to see descriptions
              and apply.
            </>
          ) : (
            <>
              Thanks for your interest in SFU Robot Soccer! We are not accepting
              applications right now.
            </>
          )}
        </p>
        <div className="flex flex-row items-center gap-4 mb-5">
          <button
            onClick={() => setTechRoles(false)}
            id={`${!techRoles ? "buttonPrimary" : "buttonSecondary"}`}
            className="flex items-center gap-2 plus-jakarta-sans-button text-sm px-4 py-2 tracking-wide rounded-md"
          >
            Business Roles
          </button>
          <button
            onClick={() => setTechRoles(true)}
            id={`${techRoles ? "buttonPrimary" : "buttonSecondary"}`}
            className="flex items-center gap-2 plus-jakarta-sans-button text-sm px-4 py-2 tracking-wide rounded-md"
          >
            Technical Roles
          </button>
        </div>
        {techRoles ? (
          <div className="flex w-full gap-10 mt-10 lg:mt-0 lg:gap-4 flex-col">
            {!APPLICATIONS_OPEN ? (
              <h2 className="plus-jakarta-sans-body text-black text-lg lg:leading-6">
                {closedMessage}
              </h2>
            ) : visibleTechRoles.length !== 0 ? (
              visibleTechRoles.map((role) => (
                <div key={role.name} className="contents">
                  <div className="flex flex-col gap-3">
                    <div className="flex flex-col lg:w-10/12">
                      <h2 className="plus-jakarta-sans-button text-xl">
                        {role.name}
                      </h2>
                      <p className="plus-jakarta-sans-body text-sm tracking-wide leading-6 text-black mt-1 mb-2">
                        {role.description}
                      </p>
                    </div>
                    <div className="flex flex-row gap-4">
                      <a
                        href={role.linkApply}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <button
                          id="buttonPrimary"
                          className="flex w-max items-center gap-2 plus-jakarta-sans-button text-sm px-6 py-2 tracking-wide rounded-md"
                        >
                          Apply Now
                          <FiArrowUpRight strokeWidth={3} />{" "}
                        </button>
                      </a>
                      {role.descriptionLink != null && (
                        <a
                          href={role.descriptionLink}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <button
                            id="buttonSecondary"
                            className="flex w-max items-center gap-2 plus-jakarta-sans-button text-sm px-6 py-2 tracking-wide rounded-md"
                          >
                            Role Description
                            <FiFileText strokeWidth={3} />{" "}
                          </button>
                        </a>
                      )}
                    </div>
                  </div>
                  <div className="lg:w-10/12 line bg-black bg-opacity-100 lg:mt-4 lg:mb-4"></div>
                </div>
              ))
            ) : (
              <h2 className="plus-jakarta-sans-body text-black text-lg lg:leading-6">
                {noRolesMessage}
              </h2>
            )}
          </div>
        ) : (
          <div className="flex w-full gap-10 mt-10 lg:mt-0 lg:gap-4 flex-col">
            {!APPLICATIONS_OPEN ? (
              <h2 className="plus-jakarta-sans-body text-black text-lg lg:leading-6">
                {closedMessage}
              </h2>
            ) : visibleBusinessRoles.length !== 0 ? (
              visibleBusinessRoles.map((role) => (
                <div key={role.name} className="contents">
                  <div className="flex flex-col gap-3">
                    <div className="flex flex-col lg:w-10/12">
                      <h2 className="plus-jakarta-sans-button text-xl">
                        {role.name}
                      </h2>
                      <p className="plus-jakarta-sans-body text-sm tracking-wide leading-6 text-black mt-1 mb-2">
                        {role.description}
                      </p>
                    </div>
                    <div className="flex flex-row gap-4">
                      <a
                        href={role.linkApply}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <button
                          id="buttonPrimary"
                          className="flex w-max items-center gap-2 plus-jakarta-sans-button text-sm px-6 py-2 tracking-wide rounded-md"
                        >
                          Apply Now
                          <FiArrowUpRight strokeWidth={3} />{" "}
                        </button>
                      </a>
                      {role.descriptionLink != null && (
                        <a
                          href={role.descriptionLink}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <button
                            id="buttonSecondary"
                            className="flex w-max items-center gap-2 plus-jakarta-sans-button text-sm px-6 py-2 tracking-wide rounded-md"
                          >
                            Role Description
                            <FiFileText strokeWidth={3} />{" "}
                          </button>
                        </a>
                      )}
                    </div>
                  </div>
                  <div className="lg:w-10/12 line bg-black bg-opacity-100 lg:mt-4 lg:mb-4"></div>
                </div>
              ))
            ) : (
              <h2 className="plus-jakarta-sans-body text-black text-lg lg:leading-6">
                {noRolesMessage}
              </h2>
            )}
          </div>
        )}
      </div>
      <Footer />
    </>
  );
};
